import { CalendarEntry } from "Components/Calendar/CalendarEntryHelper";
import { ValidData } from "Store/types/ValidData";
import { Project, SchedulePhase } from "domain-entities";
import moment, { Moment } from "moment";
import { v4 } from "uuid";

export interface ForSchedulePhase {
	start: Moment;
	end: Moment;
}

export interface SchedulePhaseModalItem {
	schedulePhase?: SchedulePhase;
	project?: Project;
	forSchedulePhase?: ForSchedulePhase;
}

export function getCalendarEntryFromSchedulePhase(
	schedulePhase: SchedulePhase
): CalendarEntry | undefined {
	if (schedulePhase.startDate && schedulePhase.endDate) {
		return {
			id: schedulePhase.id,
			startTime: schedulePhase.startDate,
			endTime: moment.unix(schedulePhase.endDate).add(1, "day").unix(),
			projectId: schedulePhase.projectId,
		};
	}
}

export function createSchedulePhase(
	startDate: Moment,
	endDate: Moment,
	projectId: string
): SchedulePhase {
	return {
		id: v4(),
		projectId,
		startDate: startDate.unix(),
		endDate: endDate.unix(),
		createdTimestamp: moment().unix(),
	};
}

export function getPartialSchedulePhaseFromCalendarEntry(
	calendarEntry: Partial<CalendarEntry> & ValidData
): Partial<SchedulePhase> & ValidData {
	return {
		id: calendarEntry.id,
		...(calendarEntry.startTime ? { startDate: calendarEntry.startTime } : {}),
		...(calendarEntry.endTime ? { endDate: calendarEntry.endTime } : {}),
	};
}
